import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPetFriendlySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.598 3.27a5.75 5.75 0 00-4.622 9.837l7.496 7.425a.749.749 0 00.182.133h.001c.137.071.285.096.427.08a.747.747 0 00.46-.218c.215-.218.431-.436.65-.652a.75.75 0 00.03-1.034 5.75 5.75 0 017.35-8.704.75.75 0 001.148-.56 5.769 5.769 0 00-.52-3.015 5.749 5.749 0 00-9.196-1.689 5.75 5.75 0 00-3.406-1.602z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.518 10.749a.75.75 0 000 1.5h.01a.75.75 0 100-1.5h-.01zM14.5 11.749a.75.75 0 000 1.5h.01a.75.75 0 000-1.5h-.01zM20.5 11.749a.75.75 0 000 1.5h.01a.75.75 0 000-1.5h-.01z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 13.75a3.751 3.751 0 00-3.751 3.752c0 .966.784 1.75 1.75 1.75h4.002a1.75 1.75 0 001.75-1.75 3.751 3.751 0 00-3.75-3.751zm-2.251 3.752a2.251 2.251 0 014.502 0 .25.25 0 01-.25.25H15.5a.25.25 0 01-.25-.25z",
    fill: "currentColor"
  })));
}

export { SvgPetFriendlySolid as ReactComponent };
